import type { IntegrationDefinition } from '@mint-lib/integration-registry';

import { makeOmniIntegration } from './makeOmniIntegration.js';
import { OMNI_URN } from './urns.js';

/**
 * The generic, OAuth, no-quirk omni platforms — one shared contract
 * (`makeOmniIntegration`), differing only in URN/display name/Google policy
 * banner. Amazon (region-aware) and Zemanta (basic-flow) live in their own
 * `@mint-lib/*-integration` packages.
 */
export const genericOmniIntegrations: IntegrationDefinition[] = [
  makeOmniIntegration({
    urn: OMNI_URN.facebook,
    displayName: 'Meta',
    direction: 'two-way',
  }),
  makeOmniIntegration({
    urn: OMNI_URN.adwords,
    displayName: 'Google Ads',
    direction: 'two-way',
    requiresGooglePolicyNotice: true,
  }),
  makeOmniIntegration({
    urn: OMNI_URN.linkedin,
    displayName: 'LinkedIn',
    direction: 'one-way',
  }),
  makeOmniIntegration({
    urn: OMNI_URN.tiktok,
    displayName: 'TikTok',
    direction: 'one-way',
  }),
  makeOmniIntegration({
    urn: OMNI_URN.dv360,
    displayName: 'DV360',
    direction: 'two-way',
  }),
  makeOmniIntegration({
    urn: OMNI_URN.bing,
    displayName: 'Microsoft Advertising',
    direction: 'two-way',
  }),
];
